import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";

/** Common Components */
import Image from "../../components/image/Image";
import Buttons from "../../components/ui/button/Buttons";
import CardSection from "../../components/ui/card/CardSection";
import FormCreator from "../../components/finalForms/FormCreator";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import ToastService from "../../services/toastService/ToastService";

/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";

/** Common Components */
import {
  profileSettings,
  PasswordForm,
} from "./config/profileSettingsConfiguration.data";

/** RTK Query */
import {
  useLazyGetUserByIdQuery,
  useUpdateUserMutation,
} from "../../app/services/userAPI";

/** CSS Files */
import "./ProfileSettings.scss";
import { useAddResetPassMutation } from "../../app/services/ResetPasswordAPI";

const ProfileSettings = () => {
  const profileSettingsRef = useRef();
  const [showPopup, setShowPopup] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  console.log(dataSource);

  const userId = useSelector((state) => state.auth.user.userId);

  const [formData, setFormData] = useState(profileSettings);

  const [
    getUserDetaileByUserId,
    {
      isLoading: isgetUserDetailLoading,
      isSuccess: isgetUserDetailSuccess,
      data: isgetUserDetaileData,
    },
  ] = useLazyGetUserByIdQuery();

  const [
    updateUserDetailsById,
    {
      isLoading: isUpdateUserLoading,
      isSuccess: isUpdateUserSuccess,
      data: updatedUserData,
    },
  ] = useUpdateUserMutation();

  const [addResetPass, {
    isSuccess: isDataSucess
  }] = useAddResetPassMutation();

  useEffect(() => {
    if (isUpdateUserSuccess && updatedUserData) {
      if (updatedUserData.errorMessage.includes("exists")) {
        ToastService.warning(updatedUserData.errorMessage);
      } else {
        ToastService.success(updatedUserData.errorMessage);
        closePopup();
        getUserDetaileByUserId(userId);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateUserSuccess, updatedUserData]);

  useEffect(() => {
    if (
      !isgetUserDetailLoading &&
      isgetUserDetailSuccess &&
      isgetUserDetaileData
    ) {
      if (isgetUserDetaileData) {
        setDataSource(isgetUserDetaileData);
        let updatedForm = { ...formData };
        updatedForm.initialState = {
          ...updatedForm.initialState,
          profilePic: `data:image/png;base64,${isgetUserDetaileData.profilePicBase64}`,
          firstName: isgetUserDetaileData.firstName,
          lastName: isgetUserDetaileData.lastName,
          userName: isgetUserDetaileData.userName,
          emailAddress: isgetUserDetaileData.emailAddress,
          phone: isgetUserDetaileData.phone,
          gender: isgetUserDetaileData.gender,
        };
        setFormData(updatedForm);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isgetUserDetailLoading, isgetUserDetailSuccess, isgetUserDetaileData]);

  useEffect(() => {
    getUserDetaileByUserId(userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleEditPersonalInfo = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleSubmit = () => {
    const userDetailData = profileSettingsRef.current.getFormData();
    if (userDetailData) {
      const requestData = {
        firstName: userDetailData.firstName,
        lastName: userDetailData.lastName,
        phone: userDetailData.phone,
        gender: userDetailData.gender,
        emailAddress: dataSource.emailAddress,
        addressLineId: dataSource.addressLineId,
        // emailAddress: dataSource.emailAddress,
        isActive: dataSource.isActive,
        isResetPassword: dataSource.isResetPassword,
        isSupperAdmin: dataSource.isSupperAdmin,
        lastLoginDate: dataSource.lastLoginDate,
        organizationId: dataSource.organizationId,
        organizationLocation: dataSource.organizationLocation,
        profilePic: userDetailData.profilePic[0]?.fileName || isgetUserDetaileData.profilePic,
        profilePicBase64: userDetailData.profilePic[0]?.base64Data || isgetUserDetaileData.profilePicBase64,
        base64File: userDetailData.profilePic[0]?.base64Data || isgetUserDetaileData.profilePicBase64,
        reportingManagerName: dataSource.reportingManagerName,
        roleId: dataSource.roleId,
        roleName: dataSource.roleName,
        state: dataSource.state,
        storagePath: dataSource.storagePath,
        isTimesheetRequired: dataSource.isTimesheetRequired,
        userID: dataSource.userID,
        userName: dataSource.userName,
        isTwoFactorAuth: dataSource.isTwoFactorAuth,
        repotingManager: dataSource.reportingManager,
      };

      updateUserDetailsById(requestData);
    }
  };
  const handleChangePasswordClick = () => {
    const UserData = profileSettingsRef.current.getFormData();

    if (UserData && UserData.password === UserData.Confirmpassword) {
      let request = {
        ...UserData,
        userId: userId,
      };
      addResetPass(request);
    }
    else if (UserData && UserData.password !== UserData.Confirmpassword) {
      ToastService.error("Password does not match")
    }
  };

  useEffect(() => {
    if (isDataSucess) {
      ToastService.success("Password reset");
    }
  }, [isDataSucess]);

  return (
    <>
      <div className="profile-containers">
        <h2 className="page-title">My Profile</h2>

        <div className="row ml-0">
          <div className="profile-headers col-2">
            <div className="profile-infos">
              <div className="images">
                <Image
                  imgCustomClassName=""
                  imagePath={
                    isgetUserDetaileData?.profilePicBase64
                      ? `data:image/png;base64,${isgetUserDetaileData.profilePicBase64}`
                      : AppIcons.ProfileIcon
                  }
                  altText="Medium Priority"
                />
              </div>
              <div className="profile-info">
                <h2>
                  {dataSource.firstName} {dataSource.lastName}
                </h2>
                <div className="roles">
                  <p>{dataSource.roleName}</p>
                </div>
                <div className="email">{dataSource.emailAddress}</div>
                <div className="phone">{dataSource.phone}</div>
              </div>
            </div>
          </div>
          <div className="col-10">
            <CardSection
              cardTitle={"Personal Information"}
              rightButton={true}
              buttonClassName="theme-btn"
              titleButtonClick={handleEditPersonalInfo}
              buttonText="Edit"
              textWithIcon={true}
              iconName="material-symbols:add-rounded"
            >
              <div className="row">
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>First Name </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.firstName}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Last Name </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.lastName}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>User Name </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.userName}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Email Address </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.emailAddress}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Contact Number </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.phone}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Organization Location </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.state}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Role </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.roleName}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Gender </span>
                    </div>
                    <div className="value">
                      <span>{dataSource.gender}</span>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="label-value">
                    <div className="label">
                      <span>Reporting Manager</span>
                    </div>
                    <div className="value">
                      <span>{dataSource.reportingManagerName}</span>
                    </div>
                  </div>
                </div>
              </div>
            </CardSection>
          </div>
        </div>
        <CardSection cardTitle={" Change Password"}>
          <form>
            <div className="cards">
              <div className="card-bodys">
                <div className="info-rows">
                  <FormCreator config={PasswordForm} ref={profileSettingsRef} />
                </div>
              </div>
            </div>
          </form>
          <div className="d-flex justify-content-end mt-2">
            {/* <Buttons
              buttonTypeClassName="dark-btn"
              buttonText="Cancel"
              onClick={closePopup}
            /> */}
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              buttonText="Change Password"
              onClick={handleChangePasswordClick}
            />
          </div>
        </CardSection>
      </div>

      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model"
          handleToggleModal={closePopup}
          modalTitle="Edit Personal Information"
          modelSizeClass="w-55"
        >
          <div className="cards">
            <div className="card-bodys">
              <div className="row">
                <FormCreator ref={profileSettingsRef} config={formData} />
                <div className="d-flex justify-content-end mt-3">
                  <Buttons
                    buttonTypeClassName="dark-btn"
                    buttonText="Cancel"
                    onClick={closePopup}
                  />
                  <Buttons
                    buttonTypeClassName="theme-btn ml-4"
                    buttonText="Save"
                    onClick={handleSubmit}
                    isLoading={isUpdateUserLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </CenterModel>
      )}
    </>
  );
};

export default ProfileSettings;
